import { PoolNote } from '@/types/untangled/pool';
import instance from './untangled-axios-v4';
import instanceV2 from './untangled-axiosv2';
import { UseAxiosOptions, useAxios } from '@vueuse/integrations/useAxios';

import { configService } from '@/services/config/config.service';
import QueryString from 'qs';
import { networkId } from '@/composables/useNetwork';

export function useGetVaultEvents() {
  return useAxios<PoolNote[]>('/vault/', instance);
}
